import { QueryClient } from '@tanstack/react-query';

/**
 * Shared app-wide QueryClient. Lives in its own module (not main.tsx) so
 * non-component code — AuthContext logout/login, the axios definitive-401
 * handler — can clear it at auth boundaries. Cached data outlives an SPA
 * logout otherwise, leaking the previous user's data to the next login.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
